
export enum ModelValue {
  Model1 = 'model-1',
  Model2 = 'model-2',
}
